/**
 * RoleBadge renders a small pill badge on role cards.
 * roleBadge: "new" | "experimental" | null
 */
export function RoleBadge({ roleBadge, lang = "fr" }) {
  if (!roleBadge) return null;

  const cfg = {
    new: {
      label: lang === "fr" ? "Nouveau" : "New",
      cls: "bg-yellow-500/90 text-yellow-950 border border-yellow-400/60",
    },
    experimental: {
      label: lang === "fr" ? "Expérimental" : "Experimental",
      cls: "bg-pink-600/90 text-white border border-pink-400/60",
    },
  }[roleBadge];

  if (!cfg) return null;

  return (
    <span className={`inline-block text-[9px] font-bold uppercase tracking-wide
      px-1.5 py-0.5 rounded-full leading-none ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}
